import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token");

export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

export const CREATE_SHIFT_REQUEST = "CREATE_SHIFT_REQUEST";
export const CREATE_SHIFT_SUCCESS = "CREATE_SHIFT_SUCCESS";
export const CREATE_SHIFT_FAILURE = "CREATE_SHIFT_FAILURE";

export const UPDATE_SHIFT_REQUEST = "UPDATE_SHIFT_REQUEST";
export const UPDATE_SHIFT_SUCCESS = "UPDATE_SHIFT_SUCCESS";
export const UPDATE_SHIFT_FAILURE = "UPDATE_SHIFT_FAILURE";

export const DELETE_SHIFT_REQUEST = "DELETE_SHIFT_REQUEST";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_FAILURE = "DELETE_SHIFT_FAILURE";

// Fetch All Shifts
export const fetchShifts = () => async (dispatch) => {
  dispatch({ type: FETCH_SHIFTS_REQUEST });
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/getShifts`, {
      headers: { Authorization: getToken() },
    });
    dispatch({
      type: FETCH_SHIFTS_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Failed to fetch shifts";
    dispatch({ type: FETCH_SHIFTS_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};

// Create Shift
export const createShift = (shiftData) => async (dispatch) => {
  dispatch({ type: CREATE_SHIFT_REQUEST });
  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/admin/createShift`,
      shiftData,
      { headers: { Authorization: getToken() } }
    );

    const data = response.data?.data;

    dispatch({
      type: CREATE_SHIFT_SUCCESS,
      payload: data && Object.keys(data).length ? data : null,
    });

    toast.success("Shift created successfully");
    return true;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message || error.message || "Create failed";
    dispatch({ type: CREATE_SHIFT_FAILURE, payload: errorMsg });
    toast.error(errorMsg);
    return false;
  }
};


// Update Shift
export const updateShift = (id, shiftData) => async (dispatch) => {
  dispatch({ type: UPDATE_SHIFT_REQUEST });
  try {
    const response = await axios.put(`${BASE_URL}/v1/api/admin/updateShift/${id}`, shiftData, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: UPDATE_SHIFT_SUCCESS, payload: response.data?.data });
    toast.success("Shift updated successfully");
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Update failed";
    dispatch({ type: UPDATE_SHIFT_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};

// Delete Shift
export const deleteShift = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SHIFT_REQUEST });
  try {
    await axios.delete(`${BASE_URL}/v1/api/admin/deleteShift/${id}`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: DELETE_SHIFT_SUCCESS, payload: id });
    toast.success("Shift deleted successfully");
  } catch (error) {
    const errorMsg = error.response?.data?.message || error.message || "Delete failed";
    dispatch({ type: DELETE_SHIFT_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};